import { Component, inject } from '@angular/core';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';
import { CurrentService } from 'src/app/services/current.service';

/**
 * Sélection du nombre de vantaux, regroupés par pourcentage d'ouverture.
 */
@Component({
  selector: 'ng-closet-doors-standard-door-number',
  templateUrl: './door-number.component.html',
  styleUrls: ['./door-number.component.scss'],
})
export class ClosetDoorsStandardDoorNumberComponent {
  readonly closetDoorsService = inject(ClosetDoorsStandardService);
  readonly current = inject(CurrentService);

  /**
   * Sélection d'un vantail : positionne le pourcentage d'ouverture du groupe correspondant.
   * Le nombre de vantaux est déjà mis à jour par [(ngModel)].
   */
  selectPanel(panelCount: number): void {
    const group = this.closetDoorsService.panelGroups.find(g => g.panels.some(p => p.panelCount === panelCount));
    this.current.closetDoors.openingPercentage = group?.percentage;
  }
}
